import { render, staticRenderFns } from "./TagMenu.vue?vue&type=template&id=ca6afa4c&scoped=true"
import script from "./TagMenu.vue?vue&type=script&lang=js"
export * from "./TagMenu.vue?vue&type=script&lang=js"
import style0 from "./TagMenu.vue?vue&type=style&index=0&id=ca6afa4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca6afa4c",
  null
  
)

export default component.exports